/**
 * Inline SVG brand icons for the connection frame.
 * Each renders at brand-accurate colors. No external dependencies.
 */

interface IconProps {
  size?: number;
}

export function GmailIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size}>
      <path fill="#4A90E2" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
    </svg>
  );
}

export function SlackIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="#fff">
      <path d="M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zM18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zM15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z" />
    </svg>
  );
}

export function LinkedInIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="#fff">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );
}

export function GitHubIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="#ccc">
      <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0 1 12 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z" />
    </svg>
  );
}

export function NotionIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="#fff">
      <path d="M4.459 4.208c.746.606 1.026.56 2.428.466l13.215-.793c.28 0 .047-.28-.046-.326L17.86 1.968c-.42-.326-.981-.7-2.055-.607L3.01 2.295c-.466.046-.56.28-.374.466zm.793 3.08v13.904c0 .747.373 1.027 1.214.98l14.523-.84c.841-.046.935-.56.935-1.167V6.354c0-.606-.233-.933-.748-.887l-15.177.887c-.56.047-.747.327-.747.933zm14.337.745c.093.42 0 .84-.42.888l-.7.14v10.264c-.608.327-1.168.514-1.635.514-.748 0-.935-.234-1.495-.933l-4.577-7.186v6.952L12.21 19s0 .84-1.168.84l-3.222.186c-.093-.186 0-.653.327-.746l.84-.233V9.854L7.822 9.76c-.094-.42.14-1.026.793-1.073l3.456-.233 4.764 7.279v-6.44l-1.215-.14c-.093-.514.28-.887.747-.933zM1.936 1.035l13.31-.98c1.634-.14 2.055-.047 3.082.7l4.249 2.986c.7.513.934.653.934 1.213v16.378c0 1.026-.373 1.634-1.68 1.726l-15.458.934c-.98.047-1.448-.093-1.962-.747l-3.129-4.06c-.56-.747-.793-1.306-.793-1.96V2.667c0-.839.374-1.54 1.447-1.632z" />
    </svg>
  );
}

export function SpotifyIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="#1DB954">
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.56.3z" />
    </svg>
  );
}

/** Monochrome glyphs for local macOS apps (white on tinted tile). Mirrors production. */
function glyphProps(size: number) {
  return {
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  } as const;
}

export function FinderIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="#fff">
      <path d="M3 7.5A2.5 2.5 0 0 1 5.5 5h3.6l2 2.4h7.4a2.5 2.5 0 0 1 2.5 2.5v7.1a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 17z" />
    </svg>
  );
}

export function TextEditIcon({ size = 22 }: IconProps) {
  return (
    <svg {...glyphProps(size)}>
      <path d="M6 3h7l4 4v14H6z" />
      <path d="M13 3v4h4" />
      <path d="M9 13.5h6M9 17h6" />
    </svg>
  );
}

export function PreviewIcon({ size = 22 }: IconProps) {
  return (
    <svg {...glyphProps(size)}>
      <circle cx="10.5" cy="10.5" r="6" />
      <path d="M15 15l5.5 5.5" />
    </svg>
  );
}

export function TerminalIcon({ size = 22 }: IconProps) {
  return (
    <svg {...glyphProps(size)}>
      <rect x="3" y="4.5" width="18" height="15" rx="3" />
      <path d="M7 9.5l3 3-3 3M12.5 15.5H17" />
    </svg>
  );
}

export function SafariIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size}>
      <circle cx="12" cy="12" r="8.5" fill="none" stroke="#fff" strokeWidth={1.8} />
      <path d="M15.5 8.5l-2.3 5.2-5.7 1.8 2.3-5.2z" fill="#fff" />
    </svg>
  );
}

export function ChromeIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size}>
      <circle cx="12" cy="12" r="8.5" fill="none" stroke="#fff" strokeWidth={1.8} />
      <circle cx="12" cy="12" r="3" fill="#fff" />
      <path d="M12 3.5V9M4.6 16.2l5-2.6M19.4 16.2l-5-2.6" stroke="#fff" strokeWidth={1.8} strokeLinecap="round" />
    </svg>
  );
}

export function MailIcon({ size = 22 }: IconProps) {
  return (
    <svg {...glyphProps(size)}>
      <rect x="3" y="5.5" width="18" height="13" rx="2.5" />
      <path d="M4 7.5l8 6 8-6" />
    </svg>
  );
}

export function CalendarIcon({ size = 22 }: IconProps) {
  return (
    <svg {...glyphProps(size)}>
      <rect x="3.5" y="5" width="17" height="16" rx="2.5" />
      <path d="M3.5 9.5h17M8 3v4M16 3v4" />
    </svg>
  );
}

export function MessagesIcon({ size = 22 }: IconProps) {
  return (
    <svg {...glyphProps(size)}>
      <path d="M4 6.5A3.5 3.5 0 0 1 7.5 3h9A3.5 3.5 0 0 1 20 6.5v6a3.5 3.5 0 0 1-3.5 3.5H12l-4.5 3.5v-3.5H7.5A3.5 3.5 0 0 1 4 12.5z" />
    </svg>
  );
}

export function MusicIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="#fff">
      <path d="M9 18.5a3 3 0 1 1-2-2.83V6.2c0-.44.28-.83.7-.97l9-3A1 1 0 0 1 18 3.2v11.3a3 3 0 1 1-2-2.83V7.1l-7 2.33z" />
    </svg>
  );
}

export function NotesIcon({ size = 22 }: IconProps) {
  return (
    <svg {...glyphProps(size)}>
      <rect x="5" y="3" width="14" height="18" rx="2" />
      <path d="M9 8.5h6M9 12h6M9 15.5h4" />
    </svg>
  );
}

export function RemindersIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size}>
      <circle cx="6.5" cy="7" r="1.6" fill="#fff" />
      <circle cx="6.5" cy="12" r="1.6" fill="#fff" />
      <circle cx="6.5" cy="17" r="1.6" fill="#fff" />
      <path d="M11 7h9M11 12h9M11 17h9" stroke="#fff" strokeWidth={1.8} strokeLinecap="round" />
    </svg>
  );
}

export function PhotosIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size}>
      <rect x="3" y="5" width="18" height="14" rx="2.5" fill="none" stroke="#fff" strokeWidth={1.8} />
      <circle cx="9" cy="10" r="1.6" fill="#fff" />
      <path d="M4 17l5-5 3.5 3.5L16 12l4 5z" fill="#fff" />
    </svg>
  );
}

export function ContactsIcon({ size = 22 }: IconProps) {
  return (
    <svg {...glyphProps(size)}>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20c1.2-3.6 3.8-5.5 7-5.5s5.8 1.9 7 5.5" />
    </svg>
  );
}

export function MapsIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size}>
      <path
        d="M12 21s-6.5-5.4-6.5-10.5A6.5 6.5 0 0 1 12 4a6.5 6.5 0 0 1 6.5 6.5C18.5 15.6 12 21 12 21z"
        fill="none"
        stroke="#fff"
        strokeWidth={1.8}
      />
      <circle cx="12" cy="10.5" r="2.2" fill="#fff" />
    </svg>
  );
}

export function SystemSettingsIcon({ size = 22 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size}>
      <path d="M4 6.5h16M4 12h16M4 17.5h16" stroke="#fff" strokeWidth={1.8} strokeLinecap="round" />
      <circle cx="9" cy="6.5" r="2.4" fill="#fff" />
      <circle cx="15" cy="12" r="2.4" fill="#fff" />
      <circle cx="8" cy="17.5" r="2.4" fill="#fff" />
    </svg>
  );
}

export function VSCodeIcon({ size = 22 }: IconProps) {
  return (
    <svg {...glyphProps(size)}>
      <path d="M8 7l-5 5 5 5M16 7l5 5-5 5M13.5 5l-3 14" />
    </svg>
  );
}

/** Union type for all supported app IDs */
export type AppId =
  | "gmail"
  | "slack"
  | "linkedin"
  | "github"
  | "notion"
  | "spotify"
  | "finder"
  | "textedit"
  | "preview"
  | "terminal"
  | "safari"
  | "chrome"
  | "apple-mail"
  | "apple-calendar"
  | "apple-messages"
  | "apple-music"
  | "apple-notes"
  | "apple-reminders"
  | "apple-photos"
  | "apple-contacts"
  | "apple-maps"
  | "system-settings"
  | "vscode";

/** Brand background color for each app's icon container */
export const APP_BG: Record<AppId, string> = {
  gmail: "bg-white",
  slack: "bg-[#4A154B]",
  linkedin: "bg-[#0A66C2]",
  github: "bg-[#1a1a1a]",
  notion: "bg-[#1a1a1a]",
  spotify: "bg-[#191414]",
  finder: "bg-[#0A84FF]",
  textedit: "bg-[#8E8E93]",
  preview: "bg-[#5E5CE6]",
  terminal: "bg-[#1C1C1E]",
  safari: "bg-[#1890FF]",
  chrome: "bg-[#EA4335]",
  "apple-mail": "bg-[#007AFF]",
  "apple-calendar": "bg-[#FF3B30]",
  "apple-messages": "bg-[#34C759]",
  "apple-music": "bg-[#FA1744]",
  "apple-notes": "bg-[#FFCC00]",
  "apple-reminders": "bg-[#FF9F0A]",
  "apple-photos": "bg-[#30B0C7]",
  "apple-contacts": "bg-[#5856D6]",
  "apple-maps": "bg-[#00C7BE]",
  "system-settings": "bg-[#8E8E93]",
  vscode: "bg-[#007ACC]",
};

/** Display name for each app */
export const APP_NAME: Record<AppId, string> = {
  gmail: "Gmail",
  slack: "Slack",
  linkedin: "LinkedIn",
  github: "GitHub",
  notion: "Notion",
  spotify: "Spotify",
  finder: "Finder",
  textedit: "TextEdit",
  preview: "Preview",
  terminal: "Terminal",
  safari: "Safari",
  chrome: "Chrome",
  "apple-mail": "Mail",
  "apple-calendar": "Calendar",
  "apple-messages": "Messages",
  "apple-music": "Music",
  "apple-notes": "Notes",
  "apple-reminders": "Reminders",
  "apple-photos": "Photos",
  "apple-contacts": "Contacts",
  "apple-maps": "Maps",
  "system-settings": "Settings",
  vscode: "VS Code",
};

/** Map from AppId to icon component */
export const APP_ICON: Record<AppId, (props: { size?: number }) => React.ReactElement> = {
  gmail: GmailIcon,
  slack: SlackIcon,
  linkedin: LinkedInIcon,
  github: GitHubIcon,
  notion: NotionIcon,
  spotify: SpotifyIcon,
  finder: FinderIcon,
  textedit: TextEditIcon,
  preview: PreviewIcon,
  terminal: TerminalIcon,
  safari: SafariIcon,
  chrome: ChromeIcon,
  "apple-mail": MailIcon,
  "apple-calendar": CalendarIcon,
  "apple-messages": MessagesIcon,
  "apple-music": MusicIcon,
  "apple-notes": NotesIcon,
  "apple-reminders": RemindersIcon,
  "apple-photos": PhotosIcon,
  "apple-contacts": ContactsIcon,
  "apple-maps": MapsIcon,
  "system-settings": SystemSettingsIcon,
  vscode: VSCodeIcon,
};

/** Display names for common Composio MCP toolkit slugs without brand icons (mirrors production). */
export const APP_MCP_DISPLAY_NAMES: Record<string, string> = {
  googlecalendar: "Google Calendar",
  googledrive: "Google Drive",
  googlesheets: "Google Sheets",
  googledocs: "Google Docs",
  googleslides: "Google Slides",
  outlook: "Outlook",
  linear: "Linear",
  jira: "Jira",
  asana: "Asana",
  trello: "Trello",
  discord: "Discord",
  zoom: "Zoom",
  salesforce: "Salesforce",
  hubspot: "HubSpot",
  gitlab: "GitLab",
  figma: "Figma",
  dropbox: "Dropbox",
};
